import "@/common/utils/initSentry";
import ReactDOM from "react-dom/client";

// Import the generated route tree
import { initializeApp } from "./common/utils/liveReload";
import { Main } from "./main";
import { installStaleBundleReload } from "./common/utils/staleBundleReload";
import { installDeployedVersionCheck } from "./common/utils/deployed-version-check";

// Before any lazy route can fail to load.
installStaleBundleReload();

// Covers the stale clients `installStaleBundleReload` cannot see: those whose
// chunks all still resolve, so nothing ever errors.
installDeployedVersionCheck();

// Deliberately not awaited so rendering is never blocked on native startup work.
// The catch is what keeps a failure here from becoming an unhandled rejection.
initializeApp().catch((error) => {
  console.error("App initialization failed:", error);
});

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Main />);
}
